import { Modal } from 'antd';
import PropList from 'pages/ProposalV3/PropList';
import React from 'react';
import { ProposalSelectedType } from './ProposalSelect';

export type ProposalSearchModalProps = {
  prcode?: string;
  visible: boolean;
  onCancel: () => void;
  phase?: string;
  setProposal?: (proposal: ProposalSelectedType) => void;
  PropOrProd?: string;
  hideAction?: boolean;
  clientname?: string;
  flagPropWithCtreference?: boolean;
};

const ProposalSearchModal = ({
  onCancel,
  visible,
  setProposal,
  phase,
  prcode,
  PropOrProd,
  hideAction,
  clientname,
  flagPropWithCtreference,
}: ProposalSearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1200} destroyOnClose footer={null} title={[]}>
      <PropList
        clientname={clientname}
        prcode={prcode}
        phase={phase}
        onSelect={setProposal}
        hideExtraAction
        PropOrProd={PropOrProd}
        flagPropWithCtreference={flagPropWithCtreference}
        hideAction={hideAction}
      />
    </Modal>
  );
};

export default ProposalSearchModal;
